export default {"src":"/_next/static/media/product.77aefdc6.svg","height":210,"width":270,"blurWidth":0,"blurHeight":0};